export enum WeekOfMonth {
    None = 0,
    First,
    Second,
    Third,
    Fourth,
    Last
}
